import { gql } from '@apollo/client'

export const CREATE_PlANOGRAM_FOR_ZONE = gql`
  mutation CreatePlanogramForZone($input: CreatePlanogramForZoneInput!) {
    createPlanogramForZone(input: $input) {
      planogram {
        id
        name
        zone {
          id
          name
        }
        fixtureType {
          id
          name
        }
        numSegments
        segments {
          segmentNumber
          shelves {
            displayShelfNumber
            idealInventory {
              upc
              vFacings
            }
          }
        }
      }
    }
  }
`
